import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import StoreInfo from '../components/StoreInfo';
import { businessInfo } from '../mock';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import YearsPopup from '../components/YearsPopup';

const ContactPage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  // Show popup every time user visits the contact page
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  // Scroll to contact form if hash is present
  useEffect(() => {
    if (location.hash === '#contact-form') {
      setTimeout(() => {
        const element = document.getElementById('contact-form');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      {/* 52 Years Popup */}
      <YearsPopup isOpen={showPopup} onClose={() => setShowPopup(false)} />
      
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white py-32 md:py-40">
        <div className="absolute inset-0">
          <img 
            src="https://lirp.cdn-website.com/1d57ed00/dms3rep/multi/opt/Streetsville+Eyecare+Mississauga+Store8-1920w.jpg"
            alt="Store location"
            className="w-full h-full object-cover opacity-30"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl">We'd love to hear from you</p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <MapPin className="w-8 h-8 text-red-600 mx-auto mb-3" />
              <h3 className="font-bold text-gray-900 mb-2">Location</h3>
              <p className="text-sm text-gray-600">{businessInfo.address.street}</p>
              <p className="text-sm text-gray-600">{businessInfo.address.unit}</p>
              <p className="text-sm text-gray-600">{businessInfo.address.city}, {businessInfo.address.province}</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <Phone className="w-8 h-8 text-red-600 mx-auto mb-3" />
              <h3 className="font-bold text-gray-900 mb-2">Phone</h3>
              <a href={`tel:${businessInfo.phone}`} className="text-gray-600 hover:text-red-600">{businessInfo.phone}</a>
              <p className="text-sm text-gray-600 mt-2">{businessInfo.email}</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <Clock className="w-8 h-8 text-red-600 mx-auto mb-3" />
              <h3 className="font-bold text-gray-900 mb-2">Hours</h3>
              <p className="text-sm text-gray-600">Mon-Wed, Fri: 10am-6pm</p>
              <p className="text-sm text-gray-600">Thu: 11:30am-7pm</p>
              <p className="text-sm text-gray-600">Sat: 10am-4pm</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form & Map */}
      <ContactForm />
      <StoreInfo />
    </div>
  );
};

export default ContactPage;
